<template>
    <div class="main-container">
        <my-header></my-header>
        <div class="container">
            <h1 style="text-align: center;font-size: 22px;">{{ extWFlowForm.bidItemName }}</h1>
            <div style="text-align: right; margin-top:20px; margin-right: 10px;" v-if="!isReadOnly">
                <el-button type="default" size="mini" @click="giveup()">弃标</el-button>
                <el-button type="default" size="mini" @click="askQuestion()">答疑/质疑</el-button>
                <el-button type="default" size="mini" @click="saveToDraft()" v-if="canBidbackFlag == 1">保存</el-button>
                <el-button v-if="type == 2 && canBidbackFlag == 1" type="primary" size="mini" @click="submit()">提交回标
                </el-button>
            </div>
            <!--招标文件-->
            <section class="small-container">
                <h3 class="iconfont iconxiala">招标文件</h3>
                <el-row class="colorLine">
                    <el-col :span="10">
                        <div style="height: 1px;background: #91002c;"></div>
                    </el-col>
                    <el-col :span="14">
                        <div style="height: 1px;background: #003570;"></div>
                    </el-col>
                </el-row>
                <el-form status-icon inline :model="wFlowFormInfo" :rules="wFlowFormInfoRules" :disabled="true"
                         ref="wFlowFormInfo" :label-width="formLabelWidth">
                    <h5>1、项目情况</h5>
                    <el-row>
                        <el-col :span="24">
                            <el-form-item label="项目概述及规模：" prop="projectOverview" class="noMarginBottom maxWidthForm">
                                <el-input type="textarea"
                                          :maxlength="500" size="mini" :rows="5" placeholder="请输入内容"
                                          v-model="wFlowFormInfo.projectOverview">
                                </el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="24">
                            <el-form-item label="投标范围/内容/要求：" prop="bidRanges" class="noMarginBottom maxWidthForm">
                                <el-input type="textarea"
                                          :maxlength="500" size="mini" :rows="5" placeholder="请输入内容"
                                          v-model="wFlowFormInfo.bidRanges">
                                </el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="24">
                            <el-form-item label="质量要求/服务要求：" prop="qualityRequiements"
                                          class="noMarginBottom maxWidthForm">
                                <el-input type="textarea"
                                          :maxlength="500" size="mini" :rows="5" placeholder="请输入内容"
                                          v-model="wFlowFormInfo.qualityRequiements">
                                </el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="招标单位：" prop="bidUnit" class="noMarginBottom">
                                <el-input v-model.trim="wFlowFormInfo.bidUnit" readonly size="mini" class="minWidth"
                                          placeholder="请输入招标单位"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="招标人姓名：" prop="bidUserName" class="noMarginBottom">
                                <el-input v-model.trim="wFlowFormInfo.bidUserName" readonly size="mini" class="minWidth"
                                          placeholder="请输入投标人姓名"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="办公地址：" prop="officeAddress" class="noMarginBottom">
                                <el-input v-model.trim="extWFlowForm.officeAddress" readonly size="mini"
                                          class="minWidth" placeholder="请输入办公地址"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="工期要求：" prop="constructionRequirements" class="noMarginBottom">
                                <el-input v-model.trim="wFlowFormInfo.constructionRequirements" readonly size="mini"
                                          class="minWidth" placeholder="请输入工期要求">
                                    <span slot="suffix">天</span>
                                </el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="供应商数量：" class="noMarginBottom">
                                <el-input v-model.trim="wFlowFormInfo.suppliersNumber" readonly size="mini"
                                          class="minWidth" placeholder="请输入工期要求"></el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row>
                        <el-row>
                            <el-col :span="12" v-if="contactList1.length>0">
                                <div style="margin-left: 110px;font-size: 13px;color: #606266">
                                    商务联系人：
                                </div>
                            </el-col>
                        </el-row>
                        <el-col :span="24">
                            <div v-for="(contact1, index) in contactList1" :key="index" style="padding-left: 250px;">
                                <el-form :model="contact1" :disabled="true" :ref="'contact1'+index"
                                         :rules="contactRules">
                                    <el-row>
                                        <el-col :span="6">
                                            <el-form-item label="" prop="contactUserName" class="noMarginBottom">
                                                <el-input v-model.trim="contact1.contactUserName" size="mini"
                                                          style="width: 150px" placeholder="联系人">
                                                </el-input>
                                            </el-form-item>
                                        </el-col>
                                        <el-col :span="6">
                                            <el-form-item label="联系电话：" prop="contactPhone" class="noMarginBottom">
                                                <el-input v-model.number="contact1.contactPhone" size="mini"
                                                          style="width: 103px" placeholder="联系电话">
                                                </el-input>
                                            </el-form-item>
                                        </el-col>
                                        <el-col :span="9">
                                            <el-form-item label="电子邮箱：" prop="contactEmail" class="noMarginBottom">
                                                <el-input v-model.trim="contact1.contactEmail" size="mini"
                                                          style="width: 191px" placeholder="电子邮箱">
                                                </el-input>
                                            </el-form-item>
                                        </el-col>
                                    </el-row>
                                </el-form>
                            </div>
                        </el-col>
                    </el-row>

                    <el-row>
                        <el-row>
                            <el-col :span="12">
                                <div style="margin-left: 110px;font-size: 13px;color: #606266"
                                     v-if="contactList2.length>0">
                                    技术联系人：
                                </div>
                            </el-col>
                        </el-row>
                        <el-col :span="24">
                            <div v-for="(contact2, index) in contactList2" :key="index" style="padding-left: 250px;">
                                <el-form :disabled="true" :model="contact2" :ref="'contact2'+index"
                                         :rules="contactRules">
                                    <el-row>
                                        <el-col :span="6">
                                            <el-form-item label="" prop="contactUserName" class="noMarginBottom">
                                                <el-input v-model.trim="contact2.contactUserName" size="mini"
                                                          style="width: 150px" placeholder="联系人">
                                                </el-input>
                                            </el-form-item>
                                        </el-col>
                                        <el-col :span="6">
                                            <el-form-item label="联系电话：" prop="contactPhone" class="noMarginBottom">
                                                <el-input v-model.number="contact2.contactPhone" size="mini"
                                                          style="width: 103px" placeholder="联系电话">
                                                </el-input>
                                            </el-form-item>
                                        </el-col>
                                        <el-col :span="9">
                                            <el-form-item label="电子邮箱：" prop="contactEmail" class="noMarginBottom">
                                                <el-input v-model.trim="contact2.contactEmail" size="mini"
                                                          style="width: 191px" placeholder="电子邮箱">
                                                </el-input>
                                            </el-form-item>
                                        </el-col>
                                    </el-row>
                                </el-form>
                            </div>
                        </el-col>
                    </el-row>
                    <el-row>
                        <el-row>
                            <el-col :span="12">
                                <div style="margin-left: 58px;color: #606266;font-size:13px;">
                                    付款节点/付款方式
                                </div>
                            </el-col>
                        </el-row>
                        <el-col :span="24">
                            <div v-for="(payment, index) in wFlowFormInfoPaymentList" :key="index"
                                 style="padding-left: 195px;">
                                <el-form :model="payment" :disabled="true" :ref="'payment'+index" :rules="paymentRules">
                                    <el-row>
                                        <el-col :span="7">
                                            <el-form-item label="" prop="paymentName" class="noMarginBottom">
                                                <el-input v-model.trim="payment.paymentName" size="mini"
                                                          style="width: 140px" placeholder="款项名称">
                                                </el-input>
                                            </el-form-item>
                                        </el-col>
                                        <el-col :span="7">
                                            <el-form-item label="付款比例：" prop="paymentRatio" class="noMarginBottom">
                                                <el-input v-model.number="payment.paymentRatio" size="mini"
                                                          style="width: 95px" placeholder="款项比例">
                                                    <i slot="suffix">%</i>
                                                </el-input>
                                            </el-form-item>
                                        </el-col>
                                        <el-col :span="8">
                                            <el-form-item label="付款条件：" prop="paymentConditions" class="noMarginBottom">
                                                <el-input v-model.trim="payment.paymentConditions" size="mini"
                                                          style="width: 178px" placeholder="付款条件">
                                                </el-input>
                                            </el-form-item>
                                        </el-col>
                                    </el-row>
                                </el-form>
                            </div>
                        </el-col>
                    </el-row>

                    <h5>2、招标节点计划安排</h5>
                    <el-row>
                        <el-col :span="12">
                            <el-form-item label="发标时间：" prop="sendBidTime" class="noMarginBottom">
                                <el-date-picker
                                    v-model="wFlowFormInfo.sendBidTime"
                                    size="mini"
                                    class="minWidth"
                                    :clearable=false
                                    align="right"
                                    type="datetime"
                                    format="yyyy-MM-dd HH:mm:ss"
                                    value-format="yyyy-MM-dd HH:mm:ss"
                                    placeholder="请选择日期">
                                </el-date-picker>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="回标截止时间：" prop="backBidEndTime" class="noMarginBottom">
                                <el-date-picker
                                    v-model="wFlowFormInfo.backBidEndTime"
                                    size="mini"
                                    class="minWidth"
                                    :clearable=false
                                    align="right"
                                    type="datetime"
                                    format="yyyy-MM-dd HH:mm:ss"
                                    value-format="yyyy-MM-dd HH:mm:ss"
                                    placeholder="请选择日期">
                                </el-date-picker>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="现场勘查时间：" prop="spotExplorationTime" class="noMarginBottom">
                                <el-date-picker
                                    v-model="wFlowFormInfo.spotExplorationTime"
                                    size="mini"
                                    class="minWidth"
                                    :clearable=false
                                    align="right"
                                    type="datetime"
                                    format="yyyy-MM-dd HH:mm:ss"
                                    value-format="yyyy-MM-dd HH:mm:ss"
                                    placeholder="请选择日期">
                                </el-date-picker>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="勘查地址：" prop="spotExplorationAddress" class="noMarginBottom">
                                <el-input v-model.trim="wFlowFormInfo.spotExplorationAddress" size="mini"
                                          class="minWidth" placeholder="请输入勘查地址"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="联系人：" prop="spotExplorationContactUserName" class="noMarginBottom">
                                <el-input v-model.trim="wFlowFormInfo.spotExplorationContactUserName" size="mini"
                                          class="minWidth" placeholder="请输入勘查地址"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="联系电话：" prop="spotExplorationPhone" class="noMarginBottom">
                                <el-input v-model.trim="wFlowFormInfo.spotExplorationPhone" size="mini" class="minWidth"
                                          placeholder="请输入勘查地址"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="质疑截止时间：" prop="questionsEndTime" class="noMarginBottom">
                                <el-date-picker
                                    v-model="wFlowFormInfo.questionsEndTime"
                                    size="mini"
                                    class="minWidth"
                                    :clearable=false
                                    align="right"
                                    type="datetime"
                                    format="yyyy-MM-dd HH:mm:ss"
                                    value-format="yyyy-MM-dd HH:mm:ss"
                                    placeholder="请选择日期">
                                </el-date-picker>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="答疑截止时间：" prop="answersEndTime" class="noMarginBottom">
                                <el-date-picker
                                    v-model="wFlowFormInfo.answersEndTime"
                                    size="mini"
                                    class="minWidth"
                                    :clearable=false
                                    align="right"
                                    type="datetime"
                                    format="yyyy-MM-dd HH:mm:ss"
                                    value-format="yyyy-MM-dd HH:mm:ss"
                                    placeholder="请选择日期">
                                </el-date-picker>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="评标截止时间：" prop="bidEvaluationEndTime" class="noMarginBottom">
                                <el-date-picker
                                    v-model="wFlowFormInfo.bidEvaluationEndTime"
                                    size="mini"
                                    class="minWidth"
                                    :clearable=false
                                    align="right"
                                    type="datetime"
                                    format="yyyy-MM-dd HH:mm:ss"
                                    value-format="yyyy-MM-dd HH:mm:ss"
                                    placeholder="请选择日期">
                                </el-date-picker>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="定标预计时间：" prop="calibrationEndTime" class="noMarginBottom">
                                <el-date-picker
                                    v-model="wFlowFormInfo.calibrationEndTime"
                                    size="mini"
                                    class="minWidth"
                                    :clearable=false
                                    align="right"
                                    type="datetime"
                                    format="yyyy-MM-dd HH:mm:ss"
                                    value-format="yyyy-MM-dd HH:mm:ss"
                                    placeholder="请选择日期">
                                </el-date-picker>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <h5>3、评标方法</h5>
                    <el-row>
                        <el-col :span="12">
                            <el-form-item label="评标方法：" prop="bidEvaluationMethod" class="noMarginBottom">
                                <el-select
                                    v-if="wFlowFormInfo.bidEvaluationMethod != 5"
                                    size="mini"
                                    class="minWidth"
                                    v-model="wFlowFormInfo.bidEvaluationMethod"
                                    placeholder="请选择">
                                    <el-option
                                        v-for="item in bidEvaluationOptions"
                                        :key="item.dictValue"
                                        :label="item.dictLabel"
                                        :value="item.dictValue">
                                    </el-option>
                                </el-select>
                                <el-select v-else
                                    size="mini"
                                    class="minWidth"
                                    v-model="wFlowFormInfo.bidEvaluationMethod">
                                    <el-option
                                        key="5"
                                        label="其他"
                                        value="其他">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="附件：" prop="bidEvaluationMethod" class="noMarginBottom" v-if="wFlowFormInfo.bidEvaluationMethod == 3 || wFlowFormInfo.bidEvaluationMethod == 4">
                                <a href="javascript:;"
                                   @click="toDownload('https://bidding-system-pro.oss-cn-beijing.aliyuncs.com/zcxt_prod/2021/6/9/%E7%BB%BC%E5%90%88%E8%AF%84%E5%88%86%E9%99%84%E4%BB%B6.xlsx','综合评分附件.xlsx')"
                                   style="color:#0091FF;">综合评分法（示例）</a>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <h5>4、标段划分</h5>
                    <el-row>
                        <el-col :span="12">
                            <el-form-item label="标段划分：" prop="segmentsNumber" class="noMarginBottom">
                                <el-select
                                    size="mini"
                                    class="minWidth"
                                    v-model="wFlowFormInfo.segmentsNumber"
                                    placeholder="请选择">
                                    <el-option
                                        :key="1"
                                        :label="1"
                                        :value="1">
                                    </el-option>
                                    <el-option
                                        :key="2"
                                        :label="2"
                                        :value="2">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                    </el-row>
                </el-form>
            </section>
            <!--保证金 10W+ 集中采购-->
            <section class="small-container">
                <h3 class="iconfont iconxiala">保证金</h3>
                <el-row class="colorLine">
                    <el-col :span="10">
                        <div style="height: 1px;background: #91002c;"></div>
                    </el-col>
                    <el-col :span="14">
                        <div style="height: 1px;background: #003570;"></div>
                    </el-col>
                </el-row>
                <el-form status-icon inline :model="wFlowFormInfo" ref="deposit" :label-width="formLabelWidth">
                    <h5>1、投标保证金情况</h5>
                    <el-row>
                        <el-col :span="12">
                            <el-form-item label="履约保证金：" prop="performanceBondFlag" class="noMarginBottom">
                                <el-radio-group v-model="wFlowFormInfo.performanceBondFlag" disabled>
                                    <el-radio :label="1">启用</el-radio>
                                    <el-radio :label="0">禁用</el-radio>
                                </el-radio-group>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12" v-if="wFlowFormInfo.performanceBondFlag == 1">
                            <el-form-item label="金额：" prop="performanceBondAmount" class="noMarginBottom">
                                <el-input class="minWidth" v-model.number="wFlowFormInfo.performanceBondAmount" size="mini" placeholder="金额" disabled>
                                    <span slot="suffix">元</span>
                                </el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row>
                        <el-col :span="12">
                            <el-form-item label="投保保证金：" prop="depositFlag" class="noMarginBottom">
                                <el-radio-group v-model="wFlowFormInfo.depositFlag" disabled>
                                    <el-radio :label="1">启用</el-radio>
                                    <el-radio :label="0">禁用</el-radio>
                                </el-radio-group>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row v-if="wFlowFormInfo.depositFlag == 1">
                        <el-col :span="12">
                            <el-form-item label="保证金缴纳截止时间：" prop="depositEndDate">
                                <el-date-picker v-model="wFlowFormInfo.depositEndDate" size="mini" class="minWidth" :clearable=false align="right" type="datetime" format="yyyy-MM-dd HH:mm:ss" value-format="yyyy-MM-dd HH:mm:ss" placeholder="请选择日期" disabled>
                                </el-date-picker>
                            </el-form-item>
                        </el-col>
                         <el-col :span="12">
                            <el-form-item label="金额：" prop="depositAmount">
                                <el-input class="minWidth" v-model.number="wFlowFormInfo.depositAmount" size="mini" placeholder="金额" disabled>
                                    <span slot="suffix">元</span>
                                </el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="收款银行联行号：" prop="depositAccountNo">
                                <el-input class="minWidth" v-model.number="wFlowFormInfo.depositAccountNo" size="mini" placeholder="请输入收款银行联行号" disabled>
                                </el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="收款银行：" prop="depositBankName">
                                <el-input class="minWidth" v-model.number="wFlowFormInfo.depositBankName" size="mini" placeholder="请输入收款银行" disabled>
                                </el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="收款名称：" prop="depositAccountName">
                                <el-input class="minWidth" v-model.trim="wFlowFormInfo.depositAccountName" size="mini" placeholder="请输入收款名称" disabled>
                                </el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="收款银行账号：" prop="depositBankNo">
                                <el-input class="minWidth" v-model.number="wFlowFormInfo.depositBankNo" size="mini" placeholder="请输入收款银行账号" disabled>
                                </el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="联系人：" prop="depositContactName">
                                <el-input class="minWidth" v-model.number="wFlowFormInfo.depositContactName" size="mini" placeholder="请输入联系人" disabled>
                                </el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="联系电话：" prop="depositContactPhone">
                                <el-input class="minWidth" v-model.number="wFlowFormInfo.depositContactPhone" size="mini" placeholder="请输入联系电话" disabled>
                                </el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row v-if="wFlowFormInfo.depositFlag == 1 || wFlowFormInfo.performanceBondFlag == 1">
                        <el-col :span="24">
                            <el-form-item label="保证金说明：" prop="depositRemarks" class="noMarginBottom">
                                <el-input type="textarea" :maxlength="500" :readonly="isReadOnly" size="mini" :rows="5" placeholder="请输入保证金说明" v-model="wFlowFormInfo.depositRemarks" style="width: 800px;" disabled>
                                </el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row v-if="wFlowFormInfo.depositFlag == 1">
                        <el-col :span="24">
                            <el-form-item label="投标保证书：" class="noMarginBottom attachmentForm" prop="depositFile">
                                <page-upload @finishUpload="(f)=>{this.finishUpload(209, f);this.$refs['deposit'].clearValidate();}" :files="attachementVO.depositFile" :editFlag="false" :attachmentType="209" :disable="true">
                                </page-upload>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row v-if="wFlowFormInfo.depositFlag == 1">
                        <el-col :span="24">
                            <el-form-item label="投标保证金相关材料：" class="noMarginBottom attachmentForm" prop="depositFile">
                                <page-upload @finishUpload="(f)=>{this.finishUpload(210, f);this.$refs['deposit'].clearValidate();}" :files="attachementVO.depositFile2" :editFlag="!isReadOnly" :attachmentType="210">
                                </page-upload>
                                <el-tooltip class="item" effect="light" placement="right-start" style="float: right;margin-top: -20px;margin-right: -30px;">
                                    <div slot="content">
                                        投标保证金相关材料说明：<br/>
                                        如已提交投标保证金，相关的银行转账，<br/>
                                        相关的转账材料等证明材料<br/>
                                    </div>
                                    <i class="el-icon-question" />
                                </el-tooltip>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <h5 v-if="wFlowFormInfo.depositFlag == 1">2、投标保证金退还条件</h5>
                    <p style="padding: 0 50px"  v-if="wFlowFormInfo.depositFlag == 1">
                        投标前需缴纳投标保证金，未缴纳单位经济标不予评审。经济标开标后30天内甲方予以退还未中标单位的投标保证金。中标单位的投标保证金于双方合同签订且投标人提交履约保函（或保证金）后给与退还。投标单位在投标过程中出现违反《中华人民共和国招标投标法》或其他法律法规文件中规定的违法/违规行为的，其投标保证金予以没收。
                    </p>
                </el-form>
            </section>
            <!--附件-->
            <section class="small-container">
                <div class="line-display">
                    <h3 class="iconfont iconxiala">招标资料</h3>
                </div>
                <el-row class="colorLine">
                    <el-col :span="10">
                        <div style="height: 1px;background: #91002c;"></div>
                    </el-col>
                    <el-col :span="14">
                        <div style="height: 1px;background: #003570;"></div>
                    </el-col>
                </el-row>
                <!-- :disabled="isReadOnly"  -->
                <el-form status-icon inline :model="attachementVO" :label-width="formLabelWidth">
                    <el-row>
                        <el-col :span="24">
                            <el-form-item label="投标人承诺书：" class="noMarginBottom attachmentForm">
                                <a href="javascript:;"
                                   @click="toDownload('https://bidding-system-pro.oss-cn-beijing.aliyuncs.com/zcxt_prod/2020/11/28/%E6%8A%95%E6%A0%87%E6%89%BF%E8%AF%BA%E4%B9%A6%EF%BC%88%E4%BE%9B%E5%BA%94%E5%95%86%E4%B8%8B%E8%BD%BD%E5%9B%9E%E4%BC%A0%E6%96%87%E4%BB%B6%EF%BC%89.docx', '投标承诺书（供应商下载回传文件）.docx')"
                                   style="color:#0091FF;">投标人承诺书</a>
                                   &nbsp;&nbsp;<a href="javascript:;"  style="color:#0091FF;" @click="preview(1)">预览</a>
                            </el-form-item>
                        </el-col>
                        <el-col :span="24">
                            <el-form-item label="招标文件和合同范本响应表：" class="noMarginBottom attachmentForm">
                                <!-- <page-upload
                                        @finishUpload="(fileList)=>{this.finishUpload(78, fileList)}"
                                        :files="attachementVO.exampleFiles"
                                        :editFlag="false"
                                        :attachmentType="78">
                                </page-upload> -->
                                <a href="javascript:;"
                                   @click="toDownload('https://bidding-system-pro.oss-cn-beijing.aliyuncs.com/zcxt_prod/2020/11/28/%E6%8B%9B%E6%A0%87%E6%96%87%E4%BB%B6%E5%92%8C%E5%90%88%E5%90%8C%E8%8C%83%E6%9C%AC%E7%9A%84%E5%9B%9E%E5%BA%94%E8%A1%A8%EF%BC%88%E4%BE%9B%E5%BA%94%E5%95%86%E4%B8%8B%E8%BD%BD%E5%9B%9E%E4%BC%A0%E6%96%87%E4%BB%B6%EF%BC%89.docx','招标文件和合同范本的回应表（供应商下载回传文件）.docx')"
                                   style="color:#0091FF;">招标文件和合同范本响应表</a>
                                   &nbsp;&nbsp;<a href="javascript:;" style="color:#0091FF;" @click="preview(2)">预览</a>
                            </el-form-item>
                        </el-col>
                        <el-col :span="24">
                            <el-form-item label="清单：" class="noMarginBottom attachmentForm">
                                <page-upload
                                    @finishUpload="(fileList)=>{this.finishUpload(203, fileList)}"
                                    :files="attachementVO.listQuotation"
                                    :editFlag="false"
                                    :attachmentType="203">
                                </page-upload>
                            </el-form-item>
                        </el-col>
                        <el-col :span="24">
                            <el-form-item label="方案：" class="noMarginBottom attachmentForm">
                                <div v-if="flowFormStatus == 11 || flowFormStatus == 12 || flowFormStatus == 13" v-for="(item, index) in attachementVO.drawingAttachments" :key="index" >{{item.attachName}}</div>
                                <page-upload
                                    v-else
                                    @finishUpload="(fileList)=>{this.finishUpload(58, fileList)}"
                                    :files="attachementVO.drawingAttachments"
                                    :editFlag="false"
                                    :attachmentType="58">
                                </page-upload>
                                
                                <div>
                                    <div v-if="flowFormStatus == 11 || flowFormStatus == 12 || flowFormStatus == 13">{{drawingFile1.schemeDrawingName}}</div>
                                    <a v-else href="javascript:;" @click="openDrawingDetail(drawingFile1.id)" style="color:#0091FF;">{{drawingFile1.schemeDrawingName}}</a>
                                </div>
                            </el-form-item>
                        </el-col>
                        <el-col :span="24">
                            <el-form-item label="图纸：" class="noMarginBottom attachmentForm">
                                <page-upload
                                    @finishUpload="(fileList)=>{this.finishUpload(225, fileList)}"
                                    :files="attachementVO.drawingAttachments225"
                                    :editFlag="false"
                                    :attachmentType="225">
                                </page-upload>
                                <div>
                                    <a href="javascript:;" @click="openDrawingDetail(drawingFile2.id)" style="color:#0091FF;">{{drawingFile2.schemeDrawingName}}</a>
                                </div>
                            </el-form-item>
                        </el-col>
                        <el-col :span="24">
                            <el-form-item label="合同：" class="noMarginBottom attachmentForm">
                                <page-upload
                                    @finishUpload="(fileList)=>{this.finishUpload(59, fileList)}"
                                    :files="attachementVO.contractAttachments"
                                    :editFlag="false"
                                    :attachmentType="59">
                                </page-upload>
                            </el-form-item>
                        </el-col>
                        <!-- <el-col :span="24"> -->
                        <!--                            <el-form-item label="招标文件附件：" class="noMarginBottom attachmentForm">-->
                        <!--                                <page-upload-->
                        <!--                                        @finishUpload="(fileList)=>{this.finishUpload(16, fileList)}"-->
                        <!--                                        :files="attachementVO.bidFileAttachments"-->
                        <!--                                        :editFlag="false"-->
                        <!--                                        :attachmentType="16">-->
                        <!--                                </page-upload>-->
                        <!--                            </el-form-item>-->
                        <!--                        </el-col>-->
                        <!--                        <el-col :span="24">-->
                        <!--                            <el-form-item label="商务标说明附件：" class="noMarginBottom attachmentForm">-->
                        <!--                                <page-upload-->
                        <!--                                        @finishUpload="(fileList)=>{this.finishUpload(61, fileList)}"-->
                        <!--                                        :files="attachementVO.businessAttachments"-->
                        <!--                                        :editFlag="false"-->
                        <!--                                        :attachmentType="61">-->
                        <!--                                </page-upload>-->
                        <!--                            </el-form-item>-->
                        <!--                        </el-col>-->
                        <!--                        <el-col :span="24">-->
                        <!--                            <el-form-item label="技术标说明附件：" class="noMarginBottom attachmentForm">-->
                        <!--                                <page-upload-->
                        <!--                                        @finishUpload="(fileList)=>{this.finishUpload(63, fileList)}"-->
                        <!--                                        :files="attachementVO.techAttachments"-->
                        <!--                                        :editFlag="false"-->
                        <!--                                        :attachmentType="63">-->
                        <!--                                </page-upload>-->
                        <!--                            </el-form-item>-->
                        <!--                        </el-col>-->
                        <el-col :span="24">
                            <el-form-item label="其他附件：" class="noMarginBottom attachmentForm">
                                <page-upload
                                    @finishUpload="(fileList)=>{this.finishUpload(77, fileList)}"
                                    :files="attachementVO.otherAttachments"
                                    :editFlag="false"
                                    :attachmentType="77">
                                </page-upload>
                            </el-form-item>
                        </el-col>
                        <el-col :span="24">
                            <el-form-item label="其他：" class="noMarginBottom attachmentForm">
                                <page-upload
                                    @finishUpload="(fileList)=>{this.finishUpload(57, fileList)}"
                                    :files="attachementVO.returnTemplateAttachments"
                                    :editFlag="false"
                                    :attachmentType="57">
                                </page-upload>
                            </el-form-item>
                        </el-col>
                        <el-col :span="24">
                            <el-form-item label="答疑标准清单：" class="noMarginBottom attachmentForm">
                                <a href="javascript:;"
                                   @click="toDownload('/static/helps/%E7%AD%94%E7%96%91%E6%A0%87%E5%87%86%E6%B8%85%E5%8D%95.xls', '答疑标准清单.xls')"
                                   style="color:#0091FF;">答疑标准清单</a>
                                   &nbsp;&nbsp;<a href="javascript:;"  style="color:#0091FF;" @click="preview(3)">预览</a>
                            </el-form-item>
                        </el-col>
                    </el-row>
                </el-form>
            </section>
            <!--附件-->
            <section class="small-container">
                <div class="line-display">
                    <h3 class="iconfont iconxiala">附件上传</h3>
                </div>
                <el-row class="colorLine">
                    <el-col :span="10">
                        <div style="height: 1px;background: #91002c;"></div>
                    </el-col>
                    <el-col :span="14">
                        <div style="height: 1px;background: #003570;"></div>
                    </el-col>
                </el-row>
                <el-form status-icon inline :model="attachementVO" ref="attachementVO" :rules="attachementVORules"
                         :label-width="formLabelWidth" style="margin:20px 0;">
                    <el-row>
                        <el-col :span="24">
                            <el-form-item label="回传附件-投标人承诺书：" prop="returnAttachments"
                                          class="noMarginBottom attachmentForm">
                                <page-upload
                                    @finishUpload="(fileList)=>{this.$refs['attachementVO'].clearValidate('returnAttachments');this.finishUpload(92, fileList)}"
                                    :files="attachementVO.returnAttachments"
                                    :editFlag="!isReadOnly"
                                    :attachmentType="92">
                                </page-upload>
                            </el-form-item>
                        </el-col>
                        <el-col :span="24">
                            <el-form-item label="回传附件-招标文件和合同范本响应表：" prop="returnAttachments2"
                                          class="noMarginBottom attachmentForm">
                                <page-upload
                                    @finishUpload="(fileList)=>{this.$refs['attachementVO'].clearValidate('returnAttachments2');this.finishUpload(93, fileList)}"
                                    :files="attachementVO.returnAttachments2"
                                    :editFlag="!isReadOnly"
                                    :attachmentType="93">
                                </page-upload>
                            </el-form-item>
                        </el-col>
                        <!-- 回传附件-清单 -->
                        <el-col :span="24">
                            <el-form-item label="已标价回标-清单：" prop="returnAttachments3"
                                          class="noMarginBottom attachmentForm">
                                <page-upload
                                    @finishUpload="(fileList)=>{this.$refs['attachementVO'].clearValidate('returnAttachments3');this.finishUpload(204, fileList)}"
                                    :files="attachementVO.returnAttachments3"
                                    :editFlag="!isReadOnly"
                                    :attachmentType="204">
                                </page-upload>
                            </el-form-item>
                        </el-col>
                        <el-col :span="24">
                            <el-form-item label="回传附件-其它：" class="noMarginBottom attachmentForm">
                                <page-upload
                                    @finishUpload="(fileList)=>{this.$refs['attachementVO'].clearValidate('otherReturnAttachments');this.finishUpload(86, fileList)}"
                                    :files="attachementVO.otherReturnAttachments"
                                    :editFlag="!isReadOnly"
                                    :attachmentType="86">
                                </page-upload>
                            </el-form-item>
                            <span style="color: #F56C6C;font-size: 12px;line-height: 33px;top: 0;left: 100px;">请勿上传包含报价信息附件</span>
                        </el-col>
                    </el-row>
                </el-form>
            </section>

            <section class="small-container" v-if="wFlowFormInfo.bidEvaluationMethod !=1">
                <h3 class="iconfont iconxiala">技术标
                    <span style="color: #F56C6C;font-size: 12px;top: 0;left: 100px;">(技术标附件必须上传)</span>
                </h3>

                <el-row class="colorLine">
                    <el-col :span="10">
                        <div style="height: 1px;background: #91002c;"></div>
                    </el-col>
                    <el-col :span="14">
                        <div style="height: 1px;background: #003570;"></div>
                    </el-col>
                </el-row>
                <div>
                    <el-table :data="techScoreTemplateList"
                              :header-cell-style="$root.tableHeaderStyle"
                              :cell-style="$root.tableCellStyle"
                              tooltip-effect="light"
                              size="mini"
                              style="width: 100%">
                        <el-table-column label="序号" type="index" width="140px">
                        </el-table-column>
                        <el-table-column
                            width="140px"
                            prop="evaluationItem"
                            label="事项">
                        </el-table-column>
                        <el-table-column
                            prop="evaluationIndicator"
                            label="分项内容">
                        </el-table-column>
                        <el-table-column width="350px"
                                         prop="evaluationDimension"
                                         label="相关附件">
                            <template slot-scope="scope">
                                <div class="attachmentDiv" style="text-align: center">
                                    <page-upload
                                        @finishUpload="(fileList)=>{$set(scope.row, 'outerAttachmentVOList', fileList.fileList)}"
                                        :notMany="true"
                                        :files="scope.row.outerAttachmentVOList"
                                        :editFlag="!isReadOnly"
                                        :attachmentType="87"
                                        :dir="'hor'">
                                    </page-upload>
                                </div>
                            </template>
                        </el-table-column>
                    </el-table>
                    <el-form :model="wFlowFormInfo" :disabled="true" status-icon inline ref="wFlowFormInfo2">
                        <el-row style="margin-top: 20px;">
                            <el-col :span="24">
                                <el-form-item label="技术标说明：" prop="technicalBidDesc"
                                              class="noMarginBottom maxWidthForm-2">
                                    <el-input type="textarea"
                                              :maxlength="500" size="mini" :rows="5" placeholder="请输入内容"
                                              v-model="wFlowFormInfo.technicalBidDesc">
                                    </el-input>
                                </el-form-item>
                            </el-col>
                        </el-row>
                    </el-form>
                </div>
            </section>


            <section class="small-container">
                <h3 class="iconfont iconxiala">清单
                    <span style="color: #F56C6C;font-size: 12px;top: 0;left: 100px;">(报价清单必须填写)</span>
                </h3>
                <el-row class="colorLine">
                    <el-col :span="10">
                        <div style="height: 1px;background: #91002c;"></div>
                    </el-col>
                    <el-col :span="14">
                        <div style="height: 1px;background: #003570;"></div>
                    </el-col>
                </el-row>
                <div>
                    <el-form :model="wFlowFormInfo" :disabled="true" status-icon inline label-width="225px">
                        <el-row>
                            <el-col :span="24">
                                <!-- 报价方式（1：总价包干，2：单价包干） -->
                                <el-form-item label="报价方式：" style="margin-bottom: 0px;width: 43.5%">
                                    <el-radio-group v-model="wFlowFormInfo.quotationMethod">
                                        <el-radio :label="1">总价包干</el-radio>
                                        <el-radio :label="0">单价包干</el-radio>
                                    </el-radio-group>
                                </el-form-item>
                                <!-- 税率（1：固定税率，2：非固定税率） -->
                                <el-form-item label="税率：" style="margin-bottom: 0px;">
                                    <el-radio-group v-model="wFlowFormInfo.taxRatioMethod">
                                        <el-radio :label="1">固定税率</el-radio>
                                        <el-radio :label="2">非固定税率</el-radio>
                                    </el-radio-group>
                                </el-form-item>
                            </el-col>
                        </el-row>
                        <el-row v-if="extWFlowForm.estimatedAmount >= 100000">
                            <el-col :span="24">
                                <el-form-item label="建筑面积：" style="margin-bottom: 0px;width: 43.5%;">
                                    <el-input v-model.trim="wFlowFormInfo.constructArea" style="margin-bottom: 0px;"
                                              size="mini" class="width100">
                                        <span slot="suffix">m²</span>
                                    </el-input>
                                </el-form-item>
                                <el-form-item label="单方：" style="margin-bottom: 0px;">
                                    <el-input v-model.trim="wFlowFormInfo.constructAreaPerM2"
                                              style="margin-bottom: 0px;"
                                              size="mini" class="width100">
                                        <span slot="suffix">元/m²</span>
                                    </el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="24">
                                <el-form-item label="服务面积/机房面积/改造面积：" style="margin-bottom: 0px;width: 43.5%;">
                                    <el-input v-model.trim="wFlowFormInfo.serviceRenovationArea"
                                              style="margin-bottom: 0px;"
                                              size="mini" class="width100">
                                        <span slot="suffix">m²</span>
                                    </el-input>
                                </el-form-item>
                                <el-form-item label="单方：" style="margin-bottom: 0px;">
                                    <el-input v-model.trim="wFlowFormInfo.serviceRenovationAreaPerM2"
                                              style="margin-bottom: 0px;"
                                              size="mini" class="width100">
                                        <span slot="suffix">元/m²</span>
                                    </el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="24">
                                <el-form-item label="租赁面积：" style="margin-bottom: 0px;width: 43.5%;">
                                    <el-input v-model.trim="wFlowFormInfo.rentalArea" style="margin-bottom: 0px;"
                                              size="mini" class="width100">
                                        <span slot="suffix">m²</span>
                                    </el-input>
                                </el-form-item>
                                <el-form-item label="单方：" style="margin-bottom: 0px;">
                                    <el-input v-model.trim="wFlowFormInfo.rentalAreaPerM2" style="margin-bottom: 0px;"
                                              size="mini" class="width100">
                                        <span slot="suffix">元/m²</span>
                                    </el-input>
                                </el-form-item>
                            </el-col>
                        </el-row>
                    </el-form>
                    <el-form status-icon inline label-width="110px">
                        <el-form-item style="margin-bottom: 0;">
                            <el-form-item label="不含税合价：">
                                <el-input size="mini" style="width: 180px" v-model="sumNoTax" disabled></el-input>
                            </el-form-item>
                            <el-form-item label="含税合价：">
                                <el-input size="mini" style="width: 180px" v-model="sumTax" disabled></el-input>
                            </el-form-item>
                            <el-form-item label="税金：">
                                <el-input size="mini" style="width: 180px" v-model="tax" disabled></el-input>
                            </el-form-item>
                            <el-button size="mini" style="margin-left: 15px" :disabled="false" @click="sumPrice">查看合价
                            </el-button>
                        </el-form-item>
                    </el-form>
                    <div style="display: inline-flex;width: 100%;padding-top: 5px">
                        <span style="width: 95%"></span>
                        <el-upload
                            action=""
                            :show-file-list="false"
                            :multiple="false"
                            :http-request="beforeFileInput"
                            :on-error="uploadErr"
                            :on-success="uploadSuc">
                            <span v-if="this.type!=1" class="text-button f14"
                                  style="float: right;width: 60px;cursor: pointer;"><i class="iconfont icondaoru2"></i> 导入</span>
                        </el-upload>
                        <div>
                            <span v-if="this.type!=1" class="text-button f14"
                                  style="float: right;margin-left: 20px;width: 68px;cursor: pointer;"
                                  @click.stop="fileOutput"><i class="iconfont icondaochu"></i> 导出</span>
                        </div>
                    </div>
                    <div style="margin-bottom: 20px;margin-left: 20px;" v-show="1 == wflowFormListFlag">
                        <inventory_BigData ref="inventory_page" :readonly="false"
                                           :segments="wFlowFormInfo.segmentsNumber" :code="extWFlowForm.categoryCode"
                                           :parentCode="extWFlowForm.parentCategoryCode" page="bidBack"
                                           :taxRatioFlag="wFlowFormInfo.taxRatioMethod"
                                           :quotationFlag="wFlowFormInfo.quotationMethod"></inventory_BigData>
                    </div>
                    <div style="margin-bottom: 20px;margin-left: 20px;" v-show="1 != wflowFormListFlag">
                        <inventory ref="inventory" :readonly="isReadOnly" :segments="wFlowFormInfo.segmentsNumber"
                                   :code="extWFlowForm.categoryCode" :parentCode="extWFlowForm.parentCategoryCode"
                                   page="bidBack" :taxRatioFlag="wFlowFormInfo.taxRatioMethod"
                                   :quotationFlag="wFlowFormInfo.quotationMethod"></inventory>
                    </div>
                    <div style="margin-bottom: 20px;margin-left: 20px;" v-if="false">
                        <inventory
                            v-if="wFlowFormInfo.quotationMethod == 1 && extWFlowForm.estimatedAmount >= 100000 && isShowFlowFormList2"
                            style="margin-top: 10px;" :validateFlag="false" ref="inventory1" :readonly="isReadOnly"
                            :code="extWFlowForm.categoryCode" :parentCode="extWFlowForm.parentCategoryCode"
                            page="bidBack" :taxRatioFlag="wFlowFormInfo.taxRatioMethod"
                            :quotationFlag="wFlowFormInfo.quotationMethod" :type="2"></inventory>
                    </div>
                    <el-form :model="wFlowFormInfo" :disabled="true" status-icon inline ref="wFlowFormInfo1">
                        <el-row style="margin-top: 20px;">
                            <el-col :span="24">
                                <el-form-item label="清单编制说明：" prop="inventoryFillDesc"
                                              class="noMarginBottom maxWidthForm-2">
                                    <el-input type="textarea"
                                              :maxlength="500" size="mini" :rows="5" placeholder="请输入内容"
                                              v-model="wFlowFormInfo.inventoryFillDesc">
                                    </el-input>
                                </el-form-item>
                            </el-col>
                        </el-row>
                    </el-form>
                </div>
            </section>
        </div>
        <el-dialog
            center
            :title="extWFlowForm.bidItemName + '-投标指南'"
            :visible.sync="showTip"
            width="1065px"
            :append-to-body="true"
            :close-on-click-modal="false" 
            :close-on-press-escape="$root.dialogAutoClose">
            <div>
                <el-form v-if="answerRemind != 1 && (extWFlowForm.flowFormStatus == 12 || extWFlowForm.flowFormStatus == 13)" status-icon inline :model="wFlowFormInfo" ref="deposit" :label-width="formLabelWidth">
                    <div class="reply-the-bidding" style="position: relative;">
                        <h5 class="iconfont iconxiala reply-text-bidding">答疑</h5>
                        <el-row class="colorLine">
                            <el-col :span="10">
                                <div style="height: 1px;background: #91002c;"></div>
                            </el-col>
                            <el-col :span="14">
                                <div style="height: 1px;background: #003570;"></div>
                            </el-col>
                        </el-row>
                    </div>
                    <h5>招标节点计划安排</h5>
                    <el-row>
                        <el-col :span="24">
                            <el-form-item label="质疑截止时间：" prop="questionsEndTime" class="noMarginBottom">
                                <el-date-picker
                                    v-model="wFlowFormInfo.questionsEndTime"
                                    size="mini"
                                    class="minWidth"
                                    :clearable=false
                                    align="right"
                                    disabled
                                    type="datetime"
                                    format="yyyy-MM-dd HH:mm:ss"
                                    value-format="yyyy-MM-dd HH:mm:ss"
                                    placeholder="请选择日期">
                                </el-date-picker>
                            </el-form-item>
                        </el-col>
                        <el-col :span="24">
                            <el-form-item label="答疑截止时间：" prop="answersEndTime" class="noMarginBottom">
                                <el-date-picker
                                    v-model="wFlowFormInfo.answersEndTime"
                                    size="mini"
                                    class="minWidth"
                                    :clearable=false
                                    align="right"
                                    disabled
                                    type="datetime"
                                    format="yyyy-MM-dd HH:mm:ss"
                                    value-format="yyyy-MM-dd HH:mm:ss"
                                    placeholder="请选择日期">
                                </el-date-picker>
                            </el-form-item>
                        </el-col>
                        <el-col :span="24">
                            <el-form-item label="回标截止时间：" prop="backBidEndTime" class="noMarginBottom">
                                <el-date-picker
                                    v-model="wFlowFormInfo.backBidEndTime"
                                    size="mini"
                                    class="minWidth"
                                    disabled
                                    :clearable=false
                                    align="right"
                                    type="datetime"
                                    format="yyyy-MM-dd HH:mm:ss"
                                    value-format="yyyy-MM-dd HH:mm:ss"
                                    placeholder="请选择日期">
                                </el-date-picker>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <h5>评标方法</h5>
                    <el-row>
                        <el-col :span="24">
                            <el-form-item label="评标方法：" prop="bidEvaluationMethod" class="noMarginBottom">
                                <el-select
                                    v-if="wFlowFormInfo.bidEvaluationMethod != 5"
                                    size="mini"
                                    class="minWidth"
                                    disabled
                                    v-model="wFlowFormInfo.bidEvaluationMethod"
                                    placeholder="请选择">
                                    <el-option
                                        v-for="item in bidEvaluationOptions"
                                        :key="item.dictValue"
                                        :label="item.dictLabel"
                                        :value="item.dictValue">
                                    </el-option>
                                </el-select>
                                <el-select v-else
                                    size="mini"
                                    class="minWidth"
                                    v-model="wFlowFormInfo.bidEvaluationMethod">
                                    <el-option
                                        key="5"
                                        label="其他"
                                        value="其他">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                        <el-col :span="24">
                            <el-form-item label="附件：" prop="bidEvaluationMethod" class="noMarginBottom" v-if="wFlowFormInfo.bidEvaluationMethod == 3 || wFlowFormInfo.bidEvaluationMethod == 4">
                                <a href="javascript:;"
                                   @click="toDownload('https://bidding-system-pro.oss-cn-beijing.aliyuncs.com/zcxt_prod/2021/6/9/%E7%BB%BC%E5%90%88%E8%AF%84%E5%88%86%E9%99%84%E4%BB%B6.xlsx','综合评分附件.xlsx')"
                                   style="color:#0091FF;">综合评分法（示例）</a>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <section class="small-container">
                        <div  class="margin-bag-text">保证金</div>
                        <h5>1、投标保证金情况</h5>
                        <el-row >
                            <el-col :span="12">
                                <el-form-item label="履约保证金：" prop="performanceBondFlag" class="noMarginBottom">
                                    <el-radio-group v-model="wFlowFormInfo.performanceBondFlag" disabled>
                                        <el-radio :label="1">启用</el-radio>
                                        <el-radio :label="0">禁用</el-radio>
                                    </el-radio-group>
                                </el-form-item>
                            </el-col>
                            <el-col :span="12" v-if="wFlowFormInfo.performanceBondFlag == 1">
                                <el-form-item label="金额：" prop="performanceBondAmount" class="noMarginBottom">
                                    <el-input class="minWidth" v-model.number="wFlowFormInfo.performanceBondAmount" size="mini" placeholder="金额" disabled>
                                        <span slot="suffix">元</span>
                                    </el-input>
                                </el-form-item>
                            </el-col>
                        </el-row>

                        <el-row>
                            <el-col :span="12">
                                <el-form-item label="投保保证金：" prop="depositFlag" class="noMarginBottom">
                                    <el-radio-group v-model="wFlowFormInfo.depositFlag" disabled>
                                        <el-radio :label="1">启用</el-radio>
                                        <el-radio :label="0">禁用</el-radio>
                                    </el-radio-group>
                                </el-form-item>
                            </el-col>
                        </el-row>
                        <el-row v-if="wFlowFormInfo.depositFlag == 1">
                            <el-col :span="12">
                                <el-form-item label="保证金缴纳截止时间：" prop="depositEndDate">
                                    <el-date-picker v-model="wFlowFormInfo.depositEndDate" size="mini" class="minWidth" :clearable=false align="right" type="datetime" format="yyyy-MM-dd HH:mm:ss" value-format="yyyy-MM-dd HH:mm:ss" placeholder="请选择日期" disabled>
                                    </el-date-picker>
                                </el-form-item>
                            </el-col>
                            <el-col :span="12">
                                <el-form-item label="金额：" prop="depositAmount">
                                    <el-input class="minWidth" v-model.number="wFlowFormInfo.depositAmount" size="mini" placeholder="金额" disabled>
                                        <span slot="suffix">元</span>
                                    </el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="12">
                                <el-form-item label="收款银行联行号：" prop="depositAccountNo">
                                    <el-input class="minWidth" v-model.number="wFlowFormInfo.depositAccountNo" size="mini" placeholder="请输入收款银行联行号" disabled>
                                    </el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="12">
                                <el-form-item label="收款银行：" prop="depositBankName">
                                    <el-input class="minWidth" v-model.number="wFlowFormInfo.depositBankName" size="mini" placeholder="请输入收款银行" disabled>
                                    </el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="12">
                                <el-form-item label="收款名称：" prop="depositAccountName">
                                    <el-input class="minWidth" v-model.trim="wFlowFormInfo.depositAccountName" size="mini" placeholder="请输入收款名称" disabled>
                                    </el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="12">
                                <el-form-item label="收款银行账号：" prop="depositBankNo">
                                    <el-input class="minWidth" v-model.number="wFlowFormInfo.depositBankNo" size="mini" placeholder="请输入收款银行账号" disabled>
                                    </el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="12">
                                <el-form-item label="联系人：" prop="depositContactName">
                                    <el-input class="minWidth" v-model.number="wFlowFormInfo.depositContactName" size="mini" placeholder="请输入联系人" disabled>
                                    </el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="12">
                                <el-form-item label="联系电话：" prop="depositContactPhone">
                                    <el-input class="minWidth" v-model.number="wFlowFormInfo.depositContactPhone" size="mini" placeholder="请输入联系电话" disabled>
                                    </el-input>
                                </el-form-item>
                            </el-col>
                        </el-row>
                        <el-row v-if="wFlowFormInfo.depositFlag == 1 || wFlowFormInfo.performanceBondFlag == 1">
                            <el-col :span="24">
                                <el-form-item label="保证金说明：" prop="depositRemarks" class="noMarginBottom">
                                    <el-input type="textarea" :maxlength="500" :readonly="isReadOnly" size="mini" :rows="5" placeholder="请输入保证金说明" v-model="wFlowFormInfo.depositRemarks" style="width: 800px;" disabled>
                                    </el-input>
                                </el-form-item>
                            </el-col>
                        </el-row>
                        <el-row v-if="wFlowFormInfo.depositFlag == 1">
                            <el-col :span="24">
                                <el-form-item label="投标保证书：" class="noMarginBottom attachmentForm" prop="depositFile">
                                    <page-upload @finishUpload="(f)=>{this.finishUpload(209, f);this.$refs['deposit'].clearValidate();}" :files="attachementVO.depositFile" :editFlag="false" :attachmentType="209" :disable="true">
                                    </page-upload>
                                </el-form-item>
                            </el-col>
                        </el-row>
                        <el-row v-if="wFlowFormInfo.depositFlag == 1">
                            <el-col :span="24">
                                <el-form-item label="投标保证金相关材料：" class="noMarginBottom attachmentForm" prop="depositFile">
                                    <page-upload @finishUpload="(f)=>{this.finishUpload(210, f);this.$refs['deposit'].clearValidate();}" :files="attachementVO.depositFile2" :editFlag="false" :attachmentType="210">
                                    </page-upload>
                                    <el-tooltip class="item" effect="light" placement="right-start" style="float: right;margin-top: -20px;margin-right: -30px;">
                                        <div slot="content">
                                            投标保证金相关材料说明：<br/>
                                            如已提交投标保证金，相关的银行转账，<br/>
                                            相关的转账材料等证明材料<br/>
                                        </div>
                                        <i class="el-icon-question" />
                                    </el-tooltip>
                                </el-form-item>
                            </el-col>
                        </el-row>
                    </section>

                    <h5 v-if="wFlowFormInfo.depositFlag == 1">2、投标保证金退还条件</h5>
                    <p style="padding: 0 50px"  v-if="wFlowFormInfo.depositFlag == 1">
                        投标前需缴纳投标保证金，未缴纳单位经济标不予评审。经济标开标后30天内甲方予以退还未中标单位的投标保证金。中标单位的投标保证金于双方合同签订且投标人提交履约保函（或保证金）后给与退还。投标单位在投标过程中出现违反《中华人民共和国招标投标法》或其他法律法规文件中规定的违法/违规行为的，其投标保证金予以没收。
                    </p>
                </el-form>
                <div v-if="backRemind != 1 && (extWFlowForm.flowFormStatus == 13)">
                    <div class="reply-the-bidding" style="position: relative;">
                        <h5 class="iconfont iconxiala reply-text-bidding">回标</h5>
                        <el-row class="colorLine">
                            <el-col :span="10">
                                <div style="height: 1px;background: #91002c;"></div>
                            </el-col>
                            <el-col :span="14">
                                <div style="height: 1px;background: #003570;"></div>
                            </el-col>
                        </el-row>
                    </div>
                    <div class="bidding-information-text  bidding-information-indent">
                        <p class="bidding-information-title">1.招标信息</p>
                        <p>招标文件、保证金、招标资料为招标相关信息，请仔细查看阅读；</p>
                    </div>
                    <div class="bidding-information-text bidding-information-indent">
                        <p class="bidding-information-title">2.附件上传</p>
                        <p>(1)投标附件通过附件上传模块上传，投标人承诺书和招标文件合同范本响应表通过下载招标资料中的模版文件进行附件内容填写，上传盖章文件；</p>
                        <p>(2)回标清单通过导出清单模块清单，填写报价后盖章上传；</p>
                        <p>(3)回标其他附件不可上传包含报价相关信息附件；</p>
                    </div>
                    <div class="bidding-information-text bidding-information-indent">
                        <p class="bidding-information-title">3.技术标</p>
                        <p>（1）技术标附件均为必传附件，依次按照技术标事项，上传技术标附件；</p>
                        <p>（2）技术标附件不可包含报价信息相关附件；</p>
                    </div>
                    <div class="bidding-information-text bidding-information-indent">
                        <p class="bidding-information-title">4.清单</p>
                        <p>（1）清单信息只需填写清单表格中的必填信息，其他信息均为查看或自动生产信息；</p>
                        <p>（2）清单可通过导出在导入的方式完成清单报价；</p>
                        <p>（3）当税率为固定税率时，清单报价信息中价格只需填写含税单价，当税率为非固定税率时，清单报价信息中需要填写税率和含税单价。</p>
                    </div>
                </div>
            </div>
            <div style="position: absolute;left: 37px; bottom:63px">
                <el-radio-group v-model="radioGreeFlag">
                    <el-radio :label="1">已阅读并知晓投标指南信息</el-radio>
                </el-radio-group>
                <!-- <div style="color: red" v-if="!radioGreeFlag">请勾选</div> -->
            </div>
            <template #footer>
                <span class="dialog-footer">
                    <el-button @click="showTip = false">取消</el-button>
                    <el-button type="primary" @click="handleSave">
                    确定
                    </el-button>
                </span>
            </template>
        </el-dialog>
        <bid-give-up ref="gvd" :wflowFormId="this.wflowFormId" :supplierId="this.supplierId"
                     :dealId="this.dealId"></bid-give-up>
    </div>
</template>

<script type="text/babel">
import MyHeader from '../common/Header.vue'
import MyFooter from '../common/Footer.vue'
import BidGiveUp from "./components/bidGiveUp";

export default {
    name: "bidOpen",
    components: {
        MyHeader, MyFooter, BidGiveUp
    },
    data() {
        return {
            flowFormStatus: this.$route.query.flowFormStatus,
            radioGreeFlag: 0,
            answerRemind: null,
            backRemind: null,
            showTip: false,
            drawingFile1: {},
            drawingFile2: {},
            parentCategoryCode:'',
            sumTax: '',
            sumNoTax: '',
            tax: '',
            wflowFormListFlag: null,
            fileList: [],
            formLabelWidth: '200px',
            bidEvaluationOptions: [],//企业性质
            type: this.$route.query.type ? this.$route.query.type : '2',//类型 1： 详情  2：编辑
            supplierId: window.sessionStorage.getItem('loginId'),
            canBidbackFlag: '',

            mapAttachmentOptions: {},
            outerMapAttachmentOptions: {},
            wFlowFormInfo: {
                bidRanges: '',
                qualityRequiements: '',
                projectOverview: '',
                bidUnit: '',
                bidUserName: '',
                constructionRequirements: '',
                quotationMethod: 1, //报价方式
                taxRatioMethod: 1, //税率


                //招标节点计划安排
                sendBidTime: '',//发标时间
                backBidEndTime: '', //回标截止时间
                spotExplorationTime: '', //现场勘查时间
                spotExplorationAddress: '', //勘查地址
                spotExplorationContactUserName: '', //联系人
                spotExplorationPhone: '', //联系电话
                questionsEndTime: '',//质疑截止时间
                answersEndTime: '',//答疑截止时间
                bidEvaluationEndTime: '',//评标截止时间
                calibrationEndTime: '',//定标预计时间

                bidEvaluationMethod: '', //评标方法
                segmentsNumber: 1,//标段
                depositFlag: 1, //投保保证金
                depositAmount: '', // 投保保证金金额
                performanceBondFlag: 1, //履约保证金
                performanceBondAmount: '', // 履约保证金金额
            },
            extWFlowForm: {
                officeAddress: '',
            },
            wflowFormId: '',

            attachementVO: {
                drawingAttachments: [],//方案/图纸
                drawingAttachments225: [],//方案/图纸
                listQuotation: [], // 清单报价
                contractAttachments: [],//合同
                bidFileAttachments: [],//招标文件附件
                businessAttachments: [], //商务标说明附件
                techAttachments: [],//技术标说明附件
                otherAttachments: [],//其他附件
                promiseFiles: [], //投标人承诺书
                exampleFiles: [], //招标文件和合同范本响应表
                returnAttachments: [],//其他回传附件
                returnAttachments2: [],//其他回传附件
                returnAttachments3: [],//清单报价附件
                otherReturnAttachments: [],
                depositFile:[],
                depositFile2:[]
            },

            contactList1: [{
                contactUserName: '',
                contactPhone: '',
                contactEmail: '',
            }],

            contactList2: [{
                contactUserName: '',
                contactPhone: '',
                contactEmail: '',
            }],

            wFlowFormInfoPaymentList: [{
                paymentName: '',
                paymentRatio: '',
                paymentConditions: '',
            }],

            sSuppliersList: [],
            techScoreTemplateList: [],
            isShowFlowFormList2: true,


            attachementVORules: {
                returnAttachments: [{
                    required: true,
                    message: '请选择投标人承诺书',
                    trigger: 'blur'
                }],
                returnAttachments2: [{
                    required: true,
                    message: '请选择招标文件和合同范本响应表',
                    trigger: 'blur'
                }],
                returnAttachments3: [{
                    required: true,
                    message: '请选清单',
                    trigger: 'blur'
                }],
                otherReturnAttachments: [{
                    required: true,
                    message: '请选择其它',
                    trigger: 'blur'
                }],
            },

            wFlowFormInfoRules: {
                sendBidTime: [{
                    required: true,
                    message: '请选择发标时间',
                    trigger: 'blur'
                }],
                backBidEndTime: [{
                    required: true,
                    message: '请选择回标截止时间',
                    trigger: 'blur'
                }],
                spotExplorationTime: [{
                    required: true,
                    message: '请选择现场勘查时间',
                    trigger: 'blur'
                }],
                spotExplorationAddress: [{
                    required: true,
                    message: '请输入勘查地址',
                    trigger: 'blur'
                }],
                spotExplorationContactUserName: [{
                    required: true,
                    message: '请输入联系人',
                    trigger: 'blur'
                }],
                spotExplorationPhone: [{
                    required: true,
                    message: '请输入联系电话',
                    trigger: 'blur'
                }],
                questionsEndTime: [{
                    required: true,
                    message: '请选择质疑截止时间',
                    trigger: 'blur'
                }],
                answersEndTime: [{
                    required: true,
                    message: '请选择答疑截止时间',
                    trigger: 'blur'
                }],
                bidEvaluationEndTime: [{
                    required: true,
                    message: '请选择评标截止时间',
                    trigger: 'blur'
                }],
                calibrationEndTime: [{
                    required: true,
                    message: '请选择定标预计时间',
                    trigger: 'blur'
                }],
                bidEvaluationMethod: [{
                    required: true,
                    message: '请选择评标方法',
                    trigger: 'blur'
                }],
                depositFlag: [{
                    required: true,
                    message: '请选择投保保证金',
                    trigger: 'blur'
                }],
                depositAmount: [{
                    required: true,
                    message: '请输入投保保证金金额',
                    trigger: 'blur'
                },
                    {
                        type: 'number',
                        message: '只能输入数字'
                    }],
                performanceBondFlag: [{
                    required: true,
                    message: '请选择履约保证金',
                    trigger: 'blur'
                }],
                performanceBondAmount: [{
                    required: true,
                    message: '请输入履约保证金金额',
                    trigger: 'blur'
                },
                    {
                        type: 'number',
                        message: '只能输入数字'
                    }],
                segmentsNumber: [{
                    required: true,
                    message: '请选择标段',
                    trigger: 'blur'
                }],
            },
            paymentRules: {
                paymentName: [{
                    required: true,
                    message: '请输入款项名称',
                    trigger: 'blur'
                }
                ],
                paymentRatio: [{
                    required: true,
                    message: '请输入付款比例',
                    trigger: 'blur'
                },
                    {
                        type: 'number',
                        message: '只能输入数字'
                    }
                ],
                paymentConditions: [{
                    required: true,
                    message: '输入付款条件',
                    trigger: 'blur'
                }
                ],
            },
            contactRules: {
                contactUserName: [{
                    required: true,
                    message: '输入联系人姓名',
                    trigger: 'blur'
                }
                ],
                contactPhone: [{
                    required: true,
                    message: '输入联系人手机',
                    trigger: 'blur'
                },
                    {
                        validator: 'regexp',
                        pattern: /^[0-9]{11}$/,
                        message: '手机号码格式不正确',
                        trigger: 'blur'
                    }
                ],
                contactEmail: [{
                    required: true,
                    message: '输入联系人电子邮件',
                    trigger: 'blur'
                },
                    {
                        validator: 'regexp',
                        pattern: /^([A-Za-z0-9_\-\.])+\@([A-Za-z0-9_\-\.])+\.([A-Za-z]{2,4})$/,
                        message: '邮箱格式不正确',
                        trigger: 'blur'
                    }
                ],
            },
        }
    },
    created() {
        this.dealId = this.$route.params.dealId;
        this.getType('bid_evaluation_method');
        this.getDetail();
    },
    computed: {
        isReadOnly() {
            if (this.type == 1) {
                return true;
            } else {
                return false;
            }
        },
    },
    mounted() {

    },
    methods: {
        // 预览
        preview (type, data,name) {
        if (type == 1) {
            window.open('https://bidding-system-pro.oss-cn-beijing.aliyuncs.com/zcxt_prod/2020/11/28/%E6%8A%95%E6%A0%87%E6%89%BF%E8%AF%BA%E4%B9%A6%EF%BC%88%E4%BE%9B%E5%BA%94%E5%95%86%E4%B8%8B%E8%BD%BD%E5%9B%9E%E4%BC%A0%E6%96%87%E4%BB%B6%EF%BC%89.pdf')
        } else if (type == 2) {
            window.open('https://bidding-system-pro.oss-cn-beijing.aliyuncs.com/zcxt_prod/2020/11/28/%E6%8B%9B%E6%A0%87%E6%96%87%E4%BB%B6%E5%92%8C%E5%90%88%E5%90%8C%E8%8C%83%E6%9C%AC%E7%9A%84%E5%9B%9E%E5%BA%94%E8%A1%A8%EF%BC%88%E4%BE%9B%E5%BA%94%E5%95%86%E4%B8%8B%E8%BD%BD%E5%9B%9E%E4%BC%A0%E6%96%87%E4%BB%B6%EF%BC%89.pdf')
        } else if (type == 3) {
            window.open('https://bidding-system-pro.oss-cn-beijing.aliyuncs.com/zcxt_prod/2020/11/28/%E7%AD%94%E7%96%91%E6%A0%87%E5%87%86%E6%B8%85%E5%8D%95.pdf')
        } else if (type == 58) {
            window.open(util.baseUrl+'/v1/public/download/preview_direct?token='+ window.localStorage.getItem('token')+'&attachmentPath='+data+'&attachmentName='+encodeURIComponent(name))
            // if (data) {
            //   data.forEach((imgObj)=>{
            //     window.open(util.baseUrl+'/v1/public/download/preview_direct?token='+ window.localStorage.getItem('token')+'&attachmentPath='+imgObj.attachPath+'&attachmentName='+encodeURIComponent(imgObj.attachName))
            //   })
            // }
            } else if (type == 225) {
            window.open(util.baseUrl+'/v1/public/download/preview_direct?token='+ window.localStorage.getItem('token')+'&attachmentPath='+data+'&attachmentName='+encodeURIComponent(name))
            // if (data) {
            //   data.forEach((imgObj)=>{
            //     window.open(util.baseUrl+'/v1/public/download/preview_direct?token='+ window.localStorage.getItem('token')+'&attachmentPath='+imgObj.attachPath+'&attachmentName='+encodeURIComponent(imgObj.attachName))
            //   })
            // }
            } else if (type == 59) {
            window.open(util.baseUrl+'/v1/public/download/preview_direct?token='+ window.localStorage.getItem('token')+'&attachmentPath='+data+'&attachmentName='+encodeURIComponent(name))
            // if (data) {
            //   data.forEach((imgObj)=>{
            //     window.open(util.baseUrl+'/v1/public/download/preview_direct?token='+ window.localStorage.getItem('token')+'&attachmentPath='+imgObj.attachPath+'&attachmentName='+encodeURIComponent(imgObj.attachName))
            //   })
            // }
            } else if (type == 77) {
            window.open(util.baseUrl+'/v1/public/download/preview_direct?token='+ window.localStorage.getItem('token')+'&attachmentPath='+data+'&attachmentName='+encodeURIComponent(name))
            // if (data) {
            //   data.forEach((imgObj)=>{
            //     window.open(util.baseUrl+'/v1/public/download/preview_direct?token='+ window.localStorage.getItem('token')+'&attachmentPath='+imgObj.attachPath+'&attachmentName='+encodeURIComponent(imgObj.attachName))
            //   })
            // }
            } else if (type == 203) {
            window.open(util.baseUrl+'/v1/public/download/preview_direct?token='+ window.localStorage.getItem('token')+'&attachmentPath='+data+'&attachmentName='+encodeURIComponent(name))
            // if (data) {
            //   data.forEach((imgObj)=>{
            //     window.open(util.baseUrl+'/v1/public/download/preview_direct?token='+ window.localStorage.getItem('token')+'&attachmentPath='+imgObj.attachPath+'&attachmentName='+encodeURIComponent(imgObj.attachName))
            //   })
            // }
            } else if (type == 57) {
            window.open(util.baseUrl+'/v1/public/download/preview_direct?token='+ window.localStorage.getItem('token')+'&attachmentPath='+data+'&attachmentName='+encodeURIComponent(name))
            // if (data) {
            //   data.forEach((imgObj)=>{
            //     window.open(util.baseUrl+'/v1/public/download/preview_direct?token='+ window.localStorage.getItem('token')+'&attachmentPath='+imgObj.attachPath+'&attachmentName='+encodeURIComponent(imgObj.attachName))
            //   })
            // }
            } else if (type == 209) {
            window.open(util.baseUrl+'/v1/public/download/preview_direct?token='+ window.localStorage.getItem('token')+'&attachmentPath='+data+'&attachmentName='+encodeURIComponent(name))
            // if (data) {
            //   data.forEach((imgObj)=>{
            //     window.open(util.baseUrl+'/v1/public/download/preview_direct?token='+ window.localStorage.getItem('token')+'&attachmentPath='+imgObj.attachPath+'&attachmentName='+encodeURIComponent(imgObj.attachName))
            //   })
            // }
            }
        },
        openDrawingDetail(id){
            window.open("#/drawingDetail?id=" + id)
        },
        giveup() {
            this.$refs['gvd'].visible = true;
        },
        sumPrice() {
            try {
                if (this.wflowFormListFlag) {
                    let id = this.type != 1 ? this.dealId : this.wflowFormId;
                    this.$root.getFunc('/v1/outerformflowHS/getFlowFromListTotal?extranet=1&dealId=' + id, (res) => {
                        this.sumTax = this.$root.rounding(res.data.data.sumTax);
                        this.sumNoTax = this.$root.rounding(res.data.data.sumNoTax);
                        this.tax = this.$root.rounding(res.data.data.tax);
                        if (this.wFlowFormInfo.constructArea) {
                            this.wFlowFormInfo.constructAreaPerM2 = (parseFloat(this.sumTax) / parseFloat(this.wFlowFormInfo.constructArea)).toFixed(2)
                        } else {
                            this.wFlowFormInfo.constructAreaPerM2 = ''
                        }
                        if (this.wFlowFormInfo.serviceRenovationArea) {
                            this.wFlowFormInfo.serviceRenovationAreaPerM2 = (parseFloat(this.sumTax) / parseFloat(this.wFlowFormInfo.serviceRenovationArea)).toFixed(2)
                        } else {
                            this.wFlowFormInfo.serviceRenovationAreaPerM2 = ''
                        }
                        if (this.wFlowFormInfo.rentalArea) {
                            this.wFlowFormInfo.rentalAreaPerM2 = (parseFloat(this.sumTax) / parseFloat(this.wFlowFormInfo.rentalArea)).toFixed(2)
                        } else {
                            this.wFlowFormInfo.rentalAreaPerM2 = ''
                        }
                    })
                    return
                }
                let listData = this.$refs['inventory'].getData();
                let sum1 = 0;
                let sum2 = 0;
                let amountWithTax = 0;
                listData.forEach(item => {
                    if (item.quotationType != 2) {
                        if (!item.unitAmountWithTax) {
                            return
                        }
                        let tempDayAmount = 1;
                        if (item.dayAmount) {
                            tempDayAmount = parseFloat(item.dayAmount);
                        }
                        let tempServiceTime = 1;
                        if (item.serviceTime) {
                            tempServiceTime = parseFloat(item.serviceTime);
                        }
                        let amountWithTax = parseFloat(item.unitAmountWithTax) * parseFloat(item.quantities) * parseFloat(tempDayAmount) * parseFloat(tempServiceTime)
                        sum1 += parseFloat(amountWithTax)
                        sum2 += parseFloat((parseFloat(amountWithTax) / (1 + parseFloat(item.taxRatio) / 100)))
                    }
                })
                this.sumTax = Number.isNaN(sum1) ? '' : sum1.toFixed(2);
                this.sumNoTax = Number.isNaN(sum2) ? '' : sum2.toFixed(2);
                this.tax = Number.isNaN(sum1 - sum2) ? '' : (sum1 - sum2).toFixed(2);
                if (this.wFlowFormInfo.constructArea) {
                    this.wFlowFormInfo.constructAreaPerM2 = (parseFloat(this.sumTax) / parseFloat(this.wFlowFormInfo.constructArea)).toFixed(2)
                } else {
                    this.wFlowFormInfo.constructAreaPerM2 = ''
                }
                if (this.wFlowFormInfo.serviceRenovationArea) {
                    this.wFlowFormInfo.serviceRenovationAreaPerM2 = (parseFloat(this.sumTax) / parseFloat(this.wFlowFormInfo.serviceRenovationArea)).toFixed(2)
                } else {
                    this.wFlowFormInfo.serviceRenovationAreaPerM2 = ''
                }
                if (this.wFlowFormInfo.rentalArea) {
                    this.wFlowFormInfo.rentalAreaPerM2 = (parseFloat(this.sumTax) / parseFloat(this.wFlowFormInfo.rentalArea)).toFixed(2)
                } else {
                    this.wFlowFormInfo.rentalAreaPerM2 = ''
                }
            } catch (e) {
                this.sumTax = '';
                this.sumNoTax = '';
                this.tax = '';
            }
        },
        uploadSuc(res) {
            if (res.code === '1') {
                let that = this;
                this.$alert(res.msg, {
                    type: 'success',
                    callback: () => {
                        that.getDetail()
                    }
                });
            } else
                this.$alert('文件导入失败！', {type: 'error'})
        },
        uploadErr() {
            this.$alert('导入失败！')
        },
        beforeFileInput(param) {
            //导入前先保存
            this.save(0, 0, (tn) => {
                if (tn)
                    this.fileInput(param, () => {
                        this.getDetail()
                    })
            }, false);
        },
        fileInput(param, fn) {
            let that = this;
            let formData = new FormData()
            formData.append('dealId', this.dealId)
            formData.append('taxRatioMethod', this.wFlowFormInfo.taxRatioMethod)
            formData.append('type', '')
            formData.append('file', param.file)
            formData.append('excelType', '5')
            this.$root.postHttp('/v1/outerformflowHS/modelExcelmportFileWithID', formData, function (res) {
                if (res.data.code === '1') {
                    that.$alert(res.data.msg, {
                        type: 'success',
                        callback: () => {
                            fn()
                        }
                    })
                }
            });
        },
        fileOutput() {
            let id = this.dealId;
            let url = this.$root.baseUrl + '/v1/outerformflowHS/public/exportBidList?dealId=' + id + '&parentCodeType=' + this.extWFlowForm.parentCategoryCode + '&codeType=' + this.extWFlowForm.categoryCode;
            window.location.href = url;
        },
        progressClick(status) {

        },
        finishUpload(fileType, fileList, contactForm) {
            if (contactForm) {
                // contactForm.sAttaches = [...contactForm.secureAttachement, ...contactForm.contractAttachement];
            } else {
                if (fileType == 92 || fileType == 93 || fileType == 86 || fileType == 204 || fileType == 210) {
                    this.outerMapAttachmentOptions[fileType] = fileList;
                } else {
                    this.mapAttachmentOptions[fileType] = fileList;
                }
            }
        },
        askQuestion() {
            this.$router.push('/questions/' + this.dealId + '/' + this.wflowFormId);
        },
        saveToDraft() {
            this.save(0, 0, () => {
            });
        },
        submit() {
            let that = this;

            that.$confirm('回标信息提交之后将不能修改，请确认是否提交？', {
                type: 'warning'
            }).then(() => {
                this.checkForm().then((res)=>{
                    if(Array.isArray(res)){
                        if(this.wFlowFormInfo.bidEvaluationMethod != 1){
                            for(let i = 0; i < this.techScoreTemplateList.length; i++){
                                let obj = this.techScoreTemplateList[i];
                                if(obj.outerAttachmentVOList && obj.outerAttachmentVOList.length == 0){
                                    this.$alert('请上传技术标附件',{
                                        type: 'warning'
                                    });
                                    return;
                                }
                            }
                        }
                        this.save(1, 0, () => {
                            that.$router.go(-1);
                        });
                    } else {
                        this.$alert(res, {
                            type: 'warning'
                        });
                    }
                }).catch(e => {
                    console.log(e);
                });
            }).catch(() => {
                // 取消按钮回调
            });

        },
        checkForm() {
            let checkPromise = [];

            let listRef = this.$refs['inventory'];
            if (!this.wflowFormListFlag && listRef) {
                checkPromise.push(listRef.validate());
            }
            checkPromise.push(this.submitFormPromise('attachementVO'));

            return Promise.all(checkPromise).then(data => {
                return data;
            })
                .catch(e => {
                    console.log(e);
                    return e;
                    // reject(e);
                });
        },
        submitFormFnc(formName) {
            let that = this;
            var f = function () {
                const p = new Promise((resolve, reject) => {
                    let form = that.$refs[formName];
                    if (Array.isArray(that.$refs[formName])) {
                        form = that.$refs[formName][0]
                    }
                    form.validate((valid) => {
                        if (valid) {
                            resolve(true);
                        } else {
                            reject('请完成必填信息的填写！');
                        }
                    });
                });
                return p;
            }
            return f;
        },
        submitFormPromise(formName) {
            return this.submitFormFnc(formName)();
        },
        save(saveFlag, sendInviteFlag, fn, showTips = true) {
            let that = this;
            let suppliers = [];
            this.sSuppliersList.forEach((item, index) => {
                suppliers.push({
                    suppliersId: item.id,
                    mainContactName: item.contactName,
                    mainContactMobile: item.contactMobile,
                });
            });

            let listRef = this.$refs['inventory'];
            let listRef1 = this.$refs['inventory1'];

            let formParams = {
                bidBackSaveFlag: saveFlag,
                wflowFormId: this.wflowFormId,
                supplierId: this.supplierId,
                techScoreTemplateList: this.techScoreTemplateList,
                dealId: this.dealId,
                wflowFormListFlag: this.wflowFormListFlag
            };
            // formParams = Object.assign({}, formParams, listRef.getData());
            if (listRef) {
                formParams.wflowFormListList = listRef.getData();
            }
            if (listRef1) {
                formParams.wflowFormListList2 = listRef1.getData();
            }

            formParams.outMapAttachmentVOs = {};
            for (let key in this.outerMapAttachmentOptions) {
                formParams.outMapAttachmentVOs[key] = this.outerMapAttachmentOptions[key].fileList;
            }

            this.$root.postHttp('/v1/outerformflowHS/bidBack', formParams, function (res) {
                if (showTips)
                    that.$alert('保存成功', '提示', {
                        confirmButtonText: '确定',
                        type: 'success',
                        callback: action => {

                        }
                    });
                fn(true);
            }, function () {
                fn(false);
            })
        },
        getType(type) {
            this.$root.getHttp('v1/sysDict/public/getDictListByDictType?dictType=' + type, (res) => {
                if (type == 'bid_evaluation_method') {
                    this.bidEvaluationOptions = res.data.data;//获取评标方法
                }
            });
        },
        handleSave() {
            if(this.radioGreeFlag != 1) {
                this.$message.error('请勾选知晓指南信息');
                return
            }
            this.$root.postHttp('v1/outerformflowHS/confirmBidRemind', { dealId: this.dealId, flowFormStatus: this.extWFlowForm.flowFormStatus }, (res) => {
                this.showTip = false
            })
        },
        getDetail() {
            let that = this;
            that.$root.postHttp('/v1/outerformflowHS/getWFlowFormList', {dealId: this.dealId}, (res) => {
                that.parentCategoryCode = res.data.data.extWFlowForm.ssuppliersCategory.parentCategoryCode;
                that.canBidbackFlag = res.data.data.canBidbackFlag;
                that.wflowFormListFlag = res.data.data.wflowFormListFlag;
                let bidInfoRef = that.$refs['bidInfo'];
                if(res.data.data.drawingId1){
                    that.drawingFile1.id = res.data.data.drawingId1
                    that.drawingFile1.schemeDrawingName = res.data.data.drawingName1
                }
                if(res.data.data.drawingId2){
                    that.drawingFile2.id = res.data.data.drawingId2
                    that.drawingFile2.schemeDrawingName = res.data.data.drawingName2
                }
                that.wFlowFormInfo = res.data.data.wflowFormInfo;
                if (bidInfoRef) {
                    that.wFlowFormInfo.officeAddress = res.data.data.extWFlowForm.officeAddress;
                    bidInfoRef.setData({...res.data.data.extWFlowForm, ...that.wFlowFormInfo});
                }

                // if (that.wFlowFormInfo.backBidDelayTime) {
                //     that.wFlowFormInfo.backBidEndTime = that.wFlowFormInfo.backBidDelayTime;
                // }
                that.extWFlowForm = res.data.data.extWFlowForm;
                that.wFlowFormInfo.bidEvaluationMethod = that.wFlowFormInfo.bidEvaluationMethod + '';
                that.wflowFormId = res.data.data.wflowFormId;
                if (that.wFlowFormInfo.bidEvaluationMethod == 5) {
                    that.wFlowFormInfo.bidEvaluationMethod = '其他' + '(' + '技术标' + that.wFlowFormInfo.techRatio + '%' + ',' + '商务标' + that.wFlowFormInfo.businessRatio + '%' + ')'
                }
                that.techScoreTemplateList = res.data.data.techScoreTemplateList;
                that.wFlowFormInfoPaymentList = res.data.data.wflowFormInfoPaymentList;

                that.extWFlowForm.categoryCode = res.data.data.extWFlowForm.ssuppliersCategory.categoryCode;
                that.extWFlowForm.parentCategoryCode = res.data.data.extWFlowForm.ssuppliersCategory.parentCategoryCode;


                that.answerRemind = res.data.data.answerRemind // 答疑阶段提醒
                that.backRemind = res.data.data.backRemind // 回标阶段提醒
                if((that.answerRemind != 1 && that.extWFlowForm.flowFormStatus == 12 ) || (that.extWFlowForm.flowFormStatus == 13 &&  (that.backRemind != 1 || that.answerRemind != 1))) {
                   this.showTip = true
                }else {
                   this.showTip = false
                }
                that.$nextTick(() => {
                    let listRef = that.$refs['inventory'];
                    let listRef_page = that.$refs['inventory_page'];
                    let listRef1 = that.$refs['inventory1'];
                    if (listRef_page && that.wflowFormListFlag == 1) {
                        listRef_page.setData(res.data.data.wflowFormListPage, {...res.data.data.wflowFormInfo, ...res.data.data.extWFlowForm.ssuppliersCategory, ...{dealId: this.dealId}});
                    }
                    if (listRef) {
                        listRef.setData(res.data.data.wflowFormListList, {...res.data.data.wflowFormInfo, ...res.data.data.extWFlowForm.ssuppliersCategory});
                    }
                    if (listRef1) {
                        if (res.data.data.wflowFormListList2.length == 0) {
                            that.isShowFlowFormList2 = false;
                        }
                        listRef1.setData(res.data.data.wflowFormListList2, {...res.data.data.wflowFormInfo, ...res.data.data.extWFlowForm.ssuppliersCategory});
                    }
                })

                that.contactList1 = res.data.data.contactList1;
                that.contactList2 = res.data.data.contactList2;

                that.attachementVO.drawingAttachments = res.data.data.mapAttachmentVOs[58] || [];
                that.attachementVO.drawingAttachments225 = res.data.data.mapAttachmentVOs[225] || [];
                that.attachementVO.listQuotation = res.data.data.mapAttachmentVOs[203] || [];
                that.attachementVO.contractAttachments = res.data.data.mapAttachmentVOs[59] || [];
                that.attachementVO.bidFileAttachments = res.data.data.mapAttachmentVOs[16] || [];
                that.attachementVO.businessAttachments = res.data.data.mapAttachmentVOs[61] || [];
                that.attachementVO.techAttachments = res.data.data.mapAttachmentVOs[63] || [];
                that.attachementVO.otherAttachments = res.data.data.mapAttachmentVOs[77] || [];
                that.attachementVO.promiseFiles = res.data.data.mapAttachmentVOs[76] || [];
                that.attachementVO.exampleFiles = res.data.data.mapAttachmentVOs[78] || [];
                that.attachementVO.returnTemplateAttachments = res.data.data.mapAttachmentVOs[57] || [];

                that.attachementVO.returnAttachments = res.data.data.outMapAttachmentVOs[92] || [];
                that.attachementVO.returnAttachments2 = res.data.data.outMapAttachmentVOs[93] || [];
                that.attachementVO.returnAttachments3 = res.data.data.outMapAttachmentVOs[204] || [];
                that.attachementVO.otherReturnAttachments = res.data.data.outMapAttachmentVOs[86] || [];
                that.attachementVO.depositFile = res.data.data.mapAttachmentVOs[209] || [];
                that.attachementVO.depositFile2 = res.data.data.outMapAttachmentVOs[210] || [];
                // that.wFlowFormInfo.depositFlag = 1
                for (let key in res.data.data.mapAttachmentVOs) {
                    if (!that.mapAttachmentOptions[key]) {
                        that.mapAttachmentOptions[key] = {}
                    }
                    that.mapAttachmentOptions[key].fileList = res.data.data.mapAttachmentVOs[key];
                }

                for (let key in res.data.data.outMapAttachmentVOs) {
                    if (!that.outerMapAttachmentOptions[key]) {
                        that.outerMapAttachmentOptions[key] = {}
                    }
                    that.outerMapAttachmentOptions[key].fileList = res.data.data.outMapAttachmentVOs[key];
                }
            });
        },
        toDownload(url, name) {
            window.location.href = url;
        },
    }
}
</script>

<style scoped lang="scss">
@import '../../assets/_var.scss';
@import "../../assets/iconfont/iconfont.css";

.main-container {
    width: 1100px;
    text-align: left;
}

.container /deep/ {
    margin-top: 60px;
    margin-bottom: 150px;
    padding-bottom: 15px;
    background-color: #ffffff;

    .text-button.el-button {
        font-size: 16px;
        text-align: left;
        color: #333333;
        line-height: 21px;
        background: white;
        border: none;
    }

    .f14 {
        font-size: 14px !important;
    }

    & .unit {
        width: 100px;
        margin-right: 5px;
    }

    & .tip {
        margin-left: 10px;
        color: $--primary-color;
        font-size: 12px;
    }

    & .add {
        float: right;
        font-size: 14px;
        cursor: pointer;

        & img {
            vertical-align: middle;
            width: 70px;
            height: 26px;
        }
    }

    & .dele {
        position: absolute;
        top: 0px;
        right: 10px;
    }

    & .dele img {
        transform: scale(1);
        transition: .5s;
        width: 34px;
        height: 34px;
    }

    .dele:hover img {
        transform: scale(1.1);
    }

    & .remarks {
        width: 95%;
    }

    & .naturalForm {
        padding: 20px 10px 5px;
        padding-left: 0px;
        padding-right: 26px;
        border: 1px solid #dcdfe6;
        border-radius: 3px;
        margin-bottom: 20px;
    }

    & h4 {
        padding: 0 30px;
        text-align: left;
        line-height: 50px;
        color: $--text-color-light;
        background: $--secondary-fill-color;
        overflow: hidden;
        position: relative;
    }

    & h4 {
        text-indent: 10px;
        line-height: 35px;
        background: $--primary-fill-color;
    }

    & h5 {
        padding: 0 30px;
    }

    .el-input__inner {
        border: none;
        border-bottom: 1px solid #C4C4C4;
        border-radius: 0px;
    }

    .el-input.is-disabled .el-input__inner, .el-textarea.is-disabled .el-textarea__inner {
        background-color: white;
        cursor: default;
    }

    .maxWidthForm {
        width: 100%;

        .el-form-item__content {
            width: calc(100% - 260px);
        }
    }

    .maxWidthForm-2 {
        width: 100%;

        .el-form-item__content {
            width: calc(100% - 100px);
        }
    }

    .el-form-item__error {
        width: 300px;
        padding: 0;
    }

    .el-form-item__label, .el-form-item__content {
        line-height: 33px;
    }

    .el-table--mini th, .el-table--mini td {
        padding: 0px;
    }
}

.box-card {
    margin-bottom: 15px;
}

.minWidth {
    width: 250px;
}

h3 {
    // background-color: #ececec;
    padding: 5px 20px;
    margin: 0;
    // margin-top: 10px;
    position: relative;
    cursor: pointer;
}

.iconxiala::before {
    position: absolute;
    left: -5px;
    font-size: 20px;
}

.colorLine {
    margin-bottom: 20px;
    padding-left: 20px;
}

h2 {
    font-size: 13px;
    margin-left: 20px;
}

.noMarginBottom {
    // margin-bottom: 0!important;
    margin-bottom: 10px !important;

    .tipWrap {
        position: relative;
        min-width: 250px;

        .tips {
            position: absolute;
            top: 16px;
            left: 100px;
            padding-left: 20px;
            font-size: 12px;
            color: $--text-color-light;
            background: url('../../assets/images/register/tip.png') no-repeat left center;
        }
    }
}

.cf:before,
.cf:after {
    content: "";
    display: table;
}

.cf:after {
    clear: both;
}

.attachmentDiv /deep/ {
    text-align: left;
    padding-top: 5px;

    .file-list {
        margin-top: 10px;
    }
}

.bidding-information-text {
    margin-bottom: 15px;
}

.margin-bag-text{
    background: #cde4fa;
    height: 30px;
    line-height: 30px;
    padding-left: 10px;
    box-sizing: border-box;
    margin-bottom: 30px;
    font-weight: 700;
}

.reply-the-bidding{
    position: relative;
    .reply-text-bidding{
        padding: 5px 20px;
    }
}

.bidding-information-indent{
    text-indent: 2em;
}
.bidding-information-title{
    font-weight: 700;
    margin: 10px 0;
    text-indent: 0em;
}
</style>



// WEBPACK FOOTER //
// src/pages/bid/bidReturnHigher.vue